/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";

export const ReciptNameColumnFormatter = (cellContent, row, rowIndex) => {
  const { sender } = row;
  const { firstname = "", lastname = "", account_number = "" } = sender || {};

  return (
    <>
      <div className="d-flex align-items-center text-capitalize">
        {`${firstname} ${lastname}`}
        {firstname.length === 0 && lastname.length === 0 && "-"}
        <br />
        {account_number === null ? "" : `- ${account_number}`}
      </div>
      <> </>
    </>
  );
};
